import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { DownloadExerciseButton } from '../Buttons'

const UpdateYourLinkedinConclusion = () => {
  const { formattedExerciseName, trackContent, documentId } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const link = {
    linkPath: `/documents/${documentId}.pdf`,
    linkText: t('conclusion_link'),
  }

  return (
    <div className="flex flex-col gap-4">
      <p>{t('start_exercise.conclusion_p1')}</p>
      <p>{t('start_exercise.your_original_summary')}</p>
      <p className="whitespace-pre-line">
        {trackContent[0]?.current_about_section
          ? trackContent[0]?.current_about_section
          : 'N/A'}
      </p>
      <p>{t('start_exercise.ayla_revised_summary')}</p>
      <p className="whitespace-pre-line">
        {trackContent[2]?.ayla_feedback
          ? trackContent[2]?.ayla_feedback
          : 'N/A'}
      </p>
      <div className="flex justify-center">
        <DownloadExerciseButton
          href={link.linkPath}
          text={t('conclusion_link')}
        />
      </div>
    </div>
  )
}
export default UpdateYourLinkedinConclusion
